import { Component, Input } from '@angular/core';
import { RoadmapItemModel } from '../../services/learning-roadmap.service';

@Component({
  selector: 'tangram-roadmap-timeline',
  templateUrl: './roadmap-timeline.component.html',
  styleUrls: ['./roadmap-timeline.component.scss']
})
export class RoadmapTimelineComponent {
  @Input() items: RoadmapItemModel[] = [];
}
